import { Navigate } from '@sorare/routing';
import { ANY_SPORT_LINEUPS_ARENA_FIXTURE } from '@sorare/core/src/constants/__generated__/routes';
import { useSportContext } from '@sorare/core/src/contexts/sport';

const ArenaLineups = () => {
  const { generateSportContextPath } = useSportContext();
  return (
    <Navigate
      to={generateSportContextPath(ANY_SPORT_LINEUPS_ARENA_FIXTURE, {
        params: { fixture: 'ongoing' },
      })}
      replace
      keepSearchParams
    />
  );
};

export default ArenaLineups;
